module.exports = __webpack_public_path__ + "img/payment_transactions.d2ab59b8.svg";